import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import MultiSegmentBar from '@/components/Chart/MultiSegmentBar/MultiSegmentBar';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { radius } from '@/styles/sizes';
import { getPercentStringFormat } from '@/utils/util';

type Props = {
  data: AISuggestionTopic[];
  selectedList: string[];
  coverageData?: CoverageData;
};

const CoverageChart = (props: Props) => {
  const color = useColor();

  const total = props.coverageData?.total_count || 0;
  const unClassified = props.coverageData?.unsubsclassification_count || 0;

  const accumulates = props.data.reduce(
    (acc, topic) => {
      const blockCount = topic.count || 0;
      acc = {
        total: acc.total + blockCount,
        selected: props.selectedList.includes(topic.name)
          ? acc.selected + blockCount
          : acc.selected,
      };
      return acc;
    },
    {
      selected: 0,
      total: 0,
    },
  );

  const convertedShares =
    (accumulates.selected * unClassified) / accumulates.total;

  return (
    <Style g={12}>
      <Flex j="space-between">
        <Typo type="body2" weight="r">
          Approximately {getPercentStringFormat(total, convertedShares)}%
          covered with selected {props.selectedList.length} topics
        </Typo>
        <Typo type="body2" weight="m">
          {getPercentStringFormat(
            total,
            total - unClassified + convertedShares,
          )}
          %
        </Typo>
      </Flex>
      <MultiSegmentBar
        total={total}
        segments={[
          {
            id: 'covered',
            value: total - unClassified,
            background: color.gray600,
          },
          {
            id: 'will',
            value: convertedShares,
            background: color.primary100,
          },
        ]}
      />
      <Flex g={16}>
        <Flex a="center" g={8}>
          <Square style={{ backgroundColor: color.gray600 }} />
          <Typo type="label3" className="text-gray-700">
            Current coverage
          </Typo>
        </Flex>

        <Flex a="center" g={8}>
          <Square style={{ background: color.primary100 }} />
          <Typo type="label3" className="text-gray-700">
            Selected topics
          </Typo>
        </Flex>
      </Flex>
    </Style>
  );
};

const Square = styled.div`
  width: 12px;
  height: 12px;
  border-radius: ${radius.token.sm}px;
`;

const Style = styled(VFlex)``;

export default CoverageChart;
